import {datadogRum} from '@datadog/browser-rum'

import * as replacementEnums from '../../store/replacements/enums'
import services from '../../config/services'

export const initialiseDataDog = (): void =>
  datadogRum.init({
    applicationId: services.DATA_DOG_APP_ID,
    clientToken: services.DATA_DOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'jacuzzi',
    env: window.TBT_ENV,
    sampleRate: 100,
    replaySampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  })

export const startSessionReplay = (): void => {
  datadogRum.addRumGlobalContext('isRecording', true)
  return datadogRum.startSessionReplayRecording()
}

export const stopSessionReplay = (): void => {
  datadogRum.addRumGlobalContext('isRecording', false)
  return datadogRum.stopSessionReplayRecording()
}

export const isSessionRecording = (): boolean => {
  const datadogGlobalContext = datadogRum.getRumGlobalContext()
  return !!datadogGlobalContext || false
}

export const isFitOptionTooLarge = (selectedFitOption: string): boolean =>
  selectedFitOption === replacementEnums.TOO_LOOSE ||
  selectedFitOption === replacementEnums.TOO_LONG

export const isFitOptionTooSmall = (selectedFitOption: string): boolean =>
  selectedFitOption === replacementEnums.TOO_TIGHT ||
  selectedFitOption === replacementEnums.TOO_SHORT
